import React, { useContext, useEffect, useState } from 'react'
import { vistaConsultorasContext } from './VistaConsultorasAdmin'
import { useAdmin } from '../../../context/AdminContext'
import "./SAConsultora.scss"
import ModalEmpConsul from '../../Modales/Admin/superAdmin/ModalEmpConsul'
// ui
import { Oval } from 'react-loader-spinner'
import { Modal } from 'react-bootstrap';

export const listaConsultoraContext = React.createContext()

function ListaConsultoras() {
    const { user, idConsultora } = useContext(vistaConsultorasContext)

    const { 
        fetchEmpleadoConsultoraById,
        empConsul,
        errorEmpConsul,
        loadingEmpConsul,
        setLoadingEmpConsul
    } = useAdmin()

    const [modalEmpleado, setModalEmpleado] = useState(false)
    const [objEmpleado, setObjEmpleado] = useState(null)

    const [idEmpleado, setIdEmpleado] = useState(null)
    const [modalDelete, setModalDelete] = useState(false)
    const [errorDel, setErrorDel] = useState(null)

    useEffect(() => {
        if(idConsultora){
            fetchEmpleadoConsultoraById(user, idConsultora)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idConsultora])

    const handleModalEmpleado = () => {
        setModalEmpleado(true)
    }

    const handleModalEditEmpleado = (id) => {
        const obj = empConsul.find((e) => e.id_empleado === id)
        setObjEmpleado(JSON.stringify(obj))
        setIdEmpleado(id)
        setModalEmpleado(true)
    }

    // DELETE EMPLEADO
    const handleModalDeleteEmpleado = (id) => {
        setIdEmpleado(id)
        setModalDelete(true)
    }

    const closeDeleteEmpleado = () => {
        setModalDelete(false)
        setIdEmpleado(null)
    }

    const handleDeleteEmpleado = async () => {
        const obj = {
            user,
            idUser: parseInt(idEmpleado),
        }
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/deleteUser`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(obj)
            })
            const data = await res.json()
            if(data.status !== 0){
                setErrorDel(data.codeError)
            } else {
                closeDeleteEmpleado()
                // actualizar empleados
                setLoadingEmpConsul(true)
                fetchEmpleadoConsultoraById(user, idConsultora)
            }
        } catch (error) {
            setErrorDel("Error: Conexión con backend.")
        }
    }

    return (
        <>
            <listaConsultoraContext.Provider value={{ user, idConsultora, idEmpleado, setIdEmpleado, objEmpleado, setObjEmpleado}}>
                <ModalEmpConsul show={modalEmpleado} onHide={()=>setModalEmpleado(false)} animation={false} dialogClassName="custom-fade-modal" />
                {/* Modal Eliminar empleado */}
                <Modal className='modal__delete' show={modalDelete} onHide={closeDeleteEmpleado} backdrop="static" centered animation={false} >
                    <Modal.Header closeButton>
                        <Modal.Title><h3>Eliminar empleado/a</h3></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>¿Está seguro de eliminar este empleado/a?</Modal.Body>
                    <Modal.Footer className='d-flex flex-column'>
                        <div className='d-flex flex-row align-items-center align-self-end'>
                            <button className='btn btn-secondary rounded-pill me-2' onClick={closeDeleteEmpleado}>Cancelar</button>
                            <button className='btn btn-danger rounded-pill' onClick={handleDeleteEmpleado}>Borrar</button>
                        </div>
                        {errorDel && <p>{errorDel}</p>}
                    </Modal.Footer>
                </Modal>
                {loadingEmpConsul ? (
                    <div className='loading__ListaUsuarios my-3 d-flex flex-column align-items-center justify-content-center'>
                        <Oval
                            visible={true}
                            height="40"
                            width="40"
                            color="#0d6efd"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                        />
                        <p className='fw-medium m-0 p-0'>Loading...</p>
                    </div>
                ) : (
                    <>
                        {errorEmpConsul ? (
                            <div className='error__ListaUsuarios py-4 d-flex flex-column align-items-center justify-content-center rounded-3'>
                                <h3 className='text-danger fw-semibold mb-2'>Oops!</h3>
                                <p className='m-0 p-0'>{errorEmpConsul}</p>
                            </div>
                        ) : (
                            <>
                                {empConsul.length === 0 ? (
                                    <div className='container__usuarios--empty py-4 d-flex flex-column align-items-center rounded-3'>
                                        <h3 className='text-green'>No tienes empleados aún.</h3>
                                        <button onClick={handleModalEmpleado} className='btn btn-sm btn-success rounded-pill px-3 fw-medium'>+ Agregar empleado</button>
                                    </div>
                                ) : (
                                    <div className='container__usuarios'>
                                        <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center mb-3'>
                                            <h4 className='text-green m-0 mb-2 mb-md-0 me-md-3'>Empleados consultora</h4>
                                            <button onClick={handleModalEmpleado} className='btn btn-sm btn-outline-success rounded-pill px-3 fw-medium'>+ Agregar empleado</button>
                                        </div>
                                        <div className='table__customU'>
                                            <div className='table__customU__header'>
                                                <div className='table__customU__cell cellU__buttons fw-bold text-green'></div>
                                                <div className='table__customU__cell cellU__id fw-bold text-center text-green'>#</div>
                                                <div className='table__customU__cell cellU__name fw-bold text-green'>Nombre</div>
                                                <div className='table__customU__cell cellU__mail fw-bold text-green'>Email</div>
                                                <div className='table__customU__cell cellU__fecha fw-bold text-green'>Fecha de creación</div>
                                                <div className='table__customU__cell cellU__puesto fw-bold text-green'>Puesto</div>
                                            </div>
                                            <div className='table__customU__body'>
                                                {empConsul.map((e,i) => (
                                                    <div key={i} className='d-flex flex-row'>
                                                        <div className='table__customU__row'>
                                                            <div className='table__customU__cell cellU__buttons'>
                                                                <button onClick={()=>handleModalEditEmpleado(e.id_empleado)} className='btn__ico--g btn border-0 p-0 btn__edit--icon'><i className="bi bi-pencil"></i></button>
                                                                <button onClick={()=>handleModalDeleteEmpleado(e.id_empleado)} className='btn__ico--g btn border-0 p-0 btn__delete--icon'><i className="bi bi-trash3"></i></button>
                                                            </div>
                                                            <div className='table__customU__cell cellU__id fw-bold text-center text-green'>{e.id_empleado}</div>
                                                            <div className='table__customU__cell cellU__name'>{e.nombre}</div>
                                                            <div className='table__customU__cell cellU__mail'>{e.mail}</div>
                                                            <div className='table__customU__cell cellU__fecha'>{e.fecha_de_creacion}</div>
                                                            <div className='table__customU__cell cellU__puesto'>
                                                                {e.fk_puesto === 1 && "Administrador"}
                                                                {e.fk_puesto === 2 && "Consultora"}
                                                                {e.fk_puesto === 3 && "Gerente"}
                                                                {e.fk_puesto === 4 && "Jefe de Área"}
                                                                {e.fk_puesto === 5 && "Empleado"}
                                                                {e.fk_puesto === 6 && "Aprobador de muestras"}
                                                                {e.fk_puesto === 7 && "Auditor externo"}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
            </listaConsultoraContext.Provider>
        </>
    )
}

export default ListaConsultoras